import {subscriptionConstants} from "../_constants";
import {__isAvailable, __isKeyAvailable} from "./commons/utility.helper";

export const userHelper = {
    isSubscriptionInGracePeriod,
    getPlanInfoForSignUp,
    isPlanInCurrentSubscriptionList,
    getPlanByUuid,
};

/**
 * Checks whether the main active subscription is in grace period or not
 *
 * @param subscriptions the array of user subscriptions needs to be checked
 * @returns {boolean} flag indicating whether subscription is in grace period
 */
function isSubscriptionInGracePeriod(subscriptions) {
    let isInGracePeriod = false;
    if(Array.isArray(subscriptions)) {
        // gather the list of known plan uuid(s)
        const mainUUIDs = subscriptionConstants.PLAN_UUID_LIST;
        // filter and check status of the subscriptions subscribed to plans with known uuid(s)
        const mainSubscriptions = subscriptions.filter(
                subscription => __isKeyAvailable(subscription, "plan") && mainUUIDs.includes(subscription.plan.uuid)
        );     // filter the main subscriptions
        const mainSubscriptionGraceCount = mainSubscriptions
                .map(subscription => (subscription.status === subscriptionConstants.SUBSCRIPTION_GRACE_PERIOD) ? 1 : 0) // if grace, then 1 else 0
                .reduce((total, currentSub) => total + currentSub, 0);                                                  // tracks total grace
    
        // if all main subscriptions are in grace then return true
        isInGracePeriod = mainSubscriptions.length > 0 && mainSubscriptions.length === mainSubscriptionGraceCount;
    }
    return isInGracePeriod;
}

/**
 * Returns the info for the plan based on the given uuid
 *
 * @param uuid the uuid of the plan
 * @return {{features: [], intro: string, header: *}} plan info
 */
function getPlanInfoForSignUp(uuid) {
    const stringUtils = require('underscore.string');
    
    const allPlans = subscriptionConstants.PLANS;
    const defaultPlan = subscriptionConstants.PLANS.FREE;
    const isFreePlan = (plan) => defaultPlan["UUID"] === plan["UUID"];
    
    let infoPlan = defaultPlan; // fallback to default (free) plan
    for (const planIdentifier in allPlans) {
        if(__isKeyAvailable(allPlans[planIdentifier], "UUID") && allPlans[planIdentifier]['UUID'] === uuid) {
            infoPlan = allPlans[planIdentifier];    // set chosen plan
        }
    }
    
    // prepare header title
    const header = isFreePlan(infoPlan)
                    ? "Start your free trial"
                    : "Sign Up";
    // prepare sub-title
    const intro = infoPlan["DESC"];
    // prepare feature list
    const features = []
    if(!stringUtils.isBlank(infoPlan["TRIAL"]))             features.push(infoPlan["TRIAL"]);
    if(!stringUtils.isBlank(infoPlan["GIST_ALLOWANCE"]))    features.push(infoPlan["GIST_ALLOWANCE"]);
    if(!stringUtils.isBlank(infoPlan["STORAGE_ALLOWANCE"])) features.push(infoPlan["STORAGE_ALLOWANCE"]);
    if(!stringUtils.isBlank(infoPlan["GIST_RECURRENCE"]))   features.push(infoPlan["GIST_RECURRENCE"]);
    if(!stringUtils.isBlank(infoPlan["GIST_RATE"]))         features.push(infoPlan["GIST_RATE"]);
    
    return {header,intro,features};
}

/**
 * Checks if plan is in the list of subscription plans
 *
 * @param plan the plan to check
 * @param subscriptions the list of subscriptions to check against
 * @return {boolean} if plan is in the subscription plans
 */
function isPlanInCurrentSubscriptionList(plan, subscriptions) {
    let isPlanAlreadySubscribed = false;
    if(Array.isArray(subscriptions)) {
        const subscriptionWithPlan = subscriptions.filter(
                subscription => __isKeyAvailable(subscription, "plan") && subscription.plan.uuid === plan.UUID
        );
        isPlanAlreadySubscribed = subscriptionWithPlan.length > 0;
    }
    return isPlanAlreadySubscribed;
}

/**
 * Get associated plan based on given uuid, returns null if not available
 *
 * @param uuid string to search for plan uuid
 * @returns {null|{TRIAL: string, GIST_RATE: string, GIST_ALLOWANCE: string, PLAN_RATE: string, GIST_RECURRENCE: string, UUID: string, STORAGE_ALLOWANCE: string, DESC: string, NAME: string}}
 */
function getPlanByUuid(uuid) {
    if(!__isAvailable(uuid)) {  // if uuid parameter is not present at all, use Free
        return subscriptionConstants.PLANS.FREE;
    } else {
        // if no uuid then use Free Plan
        if(uuid === "") {
            return subscriptionConstants.PLANS.FREE;
        } else {
            // Check if the provided UUID exists in the subscriptionConstants.PLANS object.
            for (const planKey in subscriptionConstants.PLANS) {
                if (subscriptionConstants.PLANS.hasOwnProperty(planKey)) {
                    const plan = subscriptionConstants.PLANS[planKey];
                    if (plan.UUID === uuid) {
                        return plan;
                    }
                }
            }
        }
    }
    return null;
}